import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as styles from './styles.css';
import { renderGroupIcon } from './icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TITLES = {
  addresses: 'Адреса',
  cities: 'Город',
  districts: 'Район',
  newbuildings: 'Жилые комплексы',
  shoppingCenters: 'Торговые центры',
  businessCenters: 'Бизнес-центры',
  undergrounds: 'Метро',
  railways: 'Ж/Д станции',
  villages: 'Коттеджные поселки',
  roads: 'Шоссе',
  builders: 'Застройщики',
  coworkings: 'Коворкинги',
  regionalDistricts: 'Район'
};
var TITLE_STYLES = {
  addresses: styles['addresses'],
  cities: styles['cities'],
  districts: styles['districts'],
  newbuildings: styles['newbuildings'],
  shoppingCenters: styles['shop'],
  businessCenters: styles['business'],
  undergrounds: styles['undergrounds'],
  railways: styles['railways'],
  villages: styles['villages'],
  roads: styles['roads'],
  builders: styles['builders'],
  coworkings: styles['coworkings'],
  regionalDistricts: styles['regional-districts']
};
export var SuggestionsGroup = function SuggestionsGroup(props) {
  var name = props.name;
  return /*#__PURE__*/_jsx("div", {
    className: styles['group-container'],
    "data-group": name,
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles['title'],
        children: [/*#__PURE__*/_jsx("i", _objectSpread(_objectSpread({}, mergeStyles(TITLE_STYLES[name], styles['group-logo'])), {}, {
          children: renderGroupIcon(name)
        })), TITLES[name]]
      }), props.children]
    })
  });
};